import { Router } from '@angular/router';
import { Base64 } from 'js-base64';
import { LoginResponseModel } from 'src/app/core/models/security/auth/login-response.model';
import { environment } from 'src/environments/environment';

export class LocalStorageService {

  constructor(
  ) { }

  private static authLocalStorageToken: string = `${environment.appVersion}-${environment.USERDATA_KEY}`;

  //Şifreli LocalStorage Itemini Getirir, null ise '' olarak döner
  static getEncodedLocalStorageString(): string {
    let data = localStorage.getItem(this.authLocalStorageToken);
    if (data !== null) {
      return data;
    }
    else {
      return '';
    }
  }
  static getDecodedLocalStorageString(): string {
    let data = Base64.decode(this.getEncodedLocalStorageString());
    return data;
  }
  static getDecodedLocalStorageObject(): LoginResponseModel {
    let decodedLocalStorageString = this.getDecodedLocalStorageString();
    if (decodedLocalStorageString === "") {
      decodedLocalStorageString = "{}";
    }
    var data = JSON.parse(decodedLocalStorageString)
    return data;
  }
  ///////////////////////
  static setEncodedLocalStorageItem(jsonObject: LoginResponseModel) {

    var encodedJsonString = Base64.encode(JSON.stringify(jsonObject));

    localStorage.removeItem(this.authLocalStorageToken);
    localStorage.setItem(this.authLocalStorageToken, encodedJsonString);
  }
  static delEncodedLocalStorageItem() {
    localStorage.removeItem(this.authLocalStorageToken);
  }
}
